import { v4 as uuid } from 'uuid';
import { Field } from '../../../form/decorators/Field';
import EmbeddedForm from '../../../form/EmbeddedForm';
import { PhotoPrintVariant } from '../../../types/api';

export class PhotoPrintVariantForm extends EmbeddedForm<PhotoPrintVariant> {
  key: string;

  @Field({ static: true })
  public id?: string;

  @Field()
  public name: string = '';

  @Field()
  public sortOrder = 0;

  @Field()
  public price = null as number | null;

  @Field()
  public applyToShowPhotos: boolean = false;

  @Field()
  public applyToMeetAndGreetPhotos: boolean = false;

  @Field()
  public printWidth: number = 0;

  @Field()
  public printHeight: number = 0;

  @Field()
  public shopifyIdEU: string = '';

  @Field()
  public shopifyIdUS: string = '';

  constructor(variant?: Omit<PhotoPrintVariant, 'id'> & { id?: string }) {
    const id = variant?.id ?? uuid();
    super(variant ? { ...variant, id } : undefined);
    this.key = id;
    if (variant) {
      this.id = id;
      this.name = variant.name;
      this.sortOrder = variant.sortOrder;
      this.price = variant.hasPrice ? variant.price : null;
      this.applyToShowPhotos = variant.applyToShowPhotos;
      this.applyToMeetAndGreetPhotos = variant.applyToMeetAndGreetPhotos;
      this.printWidth = variant.printWidth;
      this.printHeight = variant.printHeight;
      this.shopifyIdEU = variant.shopifyIdEU ?? '';
      this.shopifyIdUS = variant.shopifyIdUS ?? '';
    }
  }
}
